import { render } from "./PaymentMethodTypeList.vue?vue&type=template&id=0ef1e69c&scoped=true"
import script from "./PaymentMethodTypeList.vue?vue&type=script&lang=js"
export * from "./PaymentMethodTypeList.vue?vue&type=script&lang=js"

import "./PaymentMethodTypeList.vue?vue&type=style&index=0&id=0ef1e69c&lang=scss&scoped=true"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef1e69c"]])

export default __exports__